import React from "react";
import { AutocompleteWithEndAdornmentChip, LimitedTag } from "../../../shared";
import {
  Checkbox,
  ListItem,
  ListItemButton,
  ListItemText,
  TextField,
  Typography,
} from "@mui/material";
import InputControl from "../../../shared/components/InputControl";

const emptyInputStyle = {
  "& .MuiAutocomplete-inputRoot .MuiAutocomplete-input": {
    width: 0,
    minWidth: 0,
    padding: "0 !important",
  },
};

export const PlAndBsDashboardFilterSection = ({
  handleChangeFilter,
  state,
  storeList = true,
}) => {
  return (
    <React.Fragment>
      <AutocompleteWithEndAdornmentChip
        options={state.filter.options.ratios}
        label="Ratio"
        name="ratio"
        value={state.filter.values.ratio}
        handleChangeFilter={handleChangeFilter}
        groupBy={() => "All"}
        renderGroup={(params) => {
          const { values, options } = state.filter;
          const isChecked = values.ratio.length === options.ratios.length; //isAllChildChecked({ params });

          const handleHeaderClick = () => {
            handleChangeFilter({
              event: null,
              name: "ratio",
              value: isChecked ? [] : options.ratios,
            });
          };
          return (
            <React.Fragment key={params.group}>
              <ListItem
                onClick={handleHeaderClick}
                sx={{
                  flexDirection: "row",
                  alignItems: "center",
                  ":hover": {
                    cursor: "pointer",
                    backgroundColor: "rgba(0,0,0,0.04)",
                  },
                }}
              >
                <Checkbox size="small" checked={isChecked} />
                <Typography>{params.group}</Typography>
              </ListItem>
              <ListItemText>{params.children}</ListItemText>
            </React.Fragment>
          );
        }}
        limitedTag={(value) => (
          <LimitedTag
            labelKey="label"
            value={value}
            autocompleteWidth="230px"
            labelWidth="110px"
          />
        )}
        sx={{ minWidth: 230, maxWidth: "fit-content", ...emptyInputStyle }}
      />

      {storeList && (
        <AutocompleteWithEndAdornmentChip
          options={state.filter.options.stores}
          label="Store"
          name="store"
          value={state.filter.values.store}
          handleChangeFilter={handleChangeFilter}
          groupBy={(option) => option.franchisee_name}
          renderGroup={(params) => {
            const { values, options } = state.filter;
            const isAllChecked = values.store.length === options.stores.length;

            const fullOptions = options.stores.filter(
              (store) => store.franchisee_name === params.group
            );

            const selectedOptions = values.store.filter(
              (store) => store.franchisee_name === params.group
            );

            const isChecked = fullOptions.length === selectedOptions.length;

            const handleHeaderClick = ({ item }) => {
              if (item === "all") {
                handleChangeFilter({
                  event: null,
                  name: "store",
                  value: isAllChecked ? [] : options.stores,
                });
              } else {
                handleChangeFilter({
                  event: null,
                  name: "store",
                  value: isChecked
                    ? values.store.filter(
                        (store) =>
                          !selectedOptions.find(
                            (opt) =>
                              opt.franchisee_name === store.franchisee_name
                          )
                      )
                    : values.store.concat(
                        fullOptions.filter(
                          (option) =>
                            !values.store.find(
                              (selectedStore) =>
                                selectedStore.value === option.value
                            )
                        )
                      ),
                });
              }
            };

            return (
              <React.Fragment key={params.group}>
                {params.key === 0 && (
                  <ListItemButton
                    disableGutters
                    onClick={() => handleHeaderClick({ item: "all" })}
                    selected={isAllChecked}
                  >
                    <Checkbox size="small" checked={isAllChecked} />
                    <Typography>All</Typography>
                  </ListItemButton>
                )}
                {params.group && (
                  <ListItemButton
                    disableGutters
                    onClick={() => handleHeaderClick({ item: params.group })}
                    selected={isChecked}
                  >
                    <Checkbox size="small" checked={isChecked} />
                    <Typography fontWeight={500}>{params.group}</Typography>
                  </ListItemButton>
                )}
                <ListItemText>{params.children}</ListItemText>
              </React.Fragment>
            );
          }}
          limitedTag={(value) => (
            <LimitedTag
              labelKey="label"
              value={value}
              autocompleteWidth="230px"
              labelWidth="110px"
            />
          )}
          sx={{
            minWidth: 230,
            maxWidth: "fit-content",
            ...emptyInputStyle,
          }}
        />
      )}

      <InputControl
        type="dropdown"
        name="financialYear"
        label="Financial Year"
        disableCloseOnSelect
        disableClearable
        getOptionLabel={(option) => option.label}
        isOptionEqualToValue={(option, value) => option.value === value.value}
        options={state.filter.options.financialYears}
        value={state.filter.values.financialYear}
        onChange={(_, value) =>
          handleChangeFilter({ name: "financialYear", value })
        }
        renderInput={(params) => (
          <TextField
            {...params}
            label="Financial Year"
            placeholder="Financial year"
          />
        )}
        sx={{ minWidth: 150, maxWidth: "fit-content" }}
      />

      <AutocompleteWithEndAdornmentChip
        options={state.filter.options.accountMonths}
        label="Month"
        name="month"
        value={state.filter.values.month}
        handleChangeFilter={handleChangeFilter}
        groupBy={() => "Yearly"}
        renderGroup={(params) => {
          const { values, options } = state.filter;
          const checkedStatus = {
            all: values.month.length === options.accountMonths.length,
            Q1:
              values.month.filter((month) => month.quarter === "Q1").length ===
              3,
            Q2:
              values.month.filter((month) => month.quarter === "Q2").length ===
              3,
            Q3:
              values.month.filter((month) => month.quarter === "Q3").length ===
              3,
            Q4:
              values.month.filter((month) => month.quarter === "Q4").length ===
              3,
          };

          const handleHeaderClick = ({ item }) => {
            if (item === "all") {
              handleChangeFilter({
                event: null,
                name: "month",
                value: checkedStatus[item] ? [] : options.accountMonths,
              });
            } else {
              handleChangeFilter({
                event: null,
                name: "month",
                value: checkedStatus[item]
                  ? values.month.filter((month) => month.quarter !== item)
                  : values.month.concat(
                      options.accountMonths.filter(
                        (month) =>
                          month.quarter === item &&
                          !values.month.find(
                            (selectedMonth) =>
                              selectedMonth.value === month.value
                          )
                      )
                    ),
              });
            }
          };
          return (
            <React.Fragment key={params.group}>
              <ListItemButton
                onClick={() => handleHeaderClick({ item: "all" })}
                selected={checkedStatus.all}
              >
                <Checkbox size="small" checked={checkedStatus.all} />
                <Typography>{params.group}</Typography>
              </ListItemButton>
              {[
                { label: "Quarter 1 (Jul - Sep)", value: "Q1" },
                { label: "Quarter 2 (Oct - Dec)", value: "Q2" },
                { label: "Quarter 3 (Jan - Mar)", value: "Q3" },
                { label: "Quarter 4 (Apr - Jun)", value: "Q4" },
              ].map((item, index) => (
                <ListItemButton
                  key={index}
                  onClick={() => handleHeaderClick({ item: item.value })}
                  selected={checkedStatus[item.value]}
                >
                  <Checkbox size="small" checked={checkedStatus[item.value]} />
                  <Typography>{item.label}</Typography>
                </ListItemButton>
              ))}
              <ListItemText>{params.children}</ListItemText>
            </React.Fragment>
          );
        }}
        limitedTag={(value) => (
          <LimitedTag
            labelKey="label"
            value={value}
            autocompleteWidth="180px"
            labelWidth="80px"
          />
        )}
        sx={{ minWidth: 200, maxWidth: "fit-content", ...emptyInputStyle }}
      />
    </React.Fragment>
  );
};
